export interface LibConfig {
	showTooltip?: boolean;
	showToday?: boolean;
	monthsInPast?: number;
	monthsInFuture?: number;
	skipDays?: number[];
}
